import { render, staticRenderFns } from "./StethoscopeAction.vue?vue&type=template&id=158b7ff7&scoped=true&"
import script from "./StethoscopeAction.vue?vue&type=script&lang=js&"
export * from "./StethoscopeAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158b7ff7",
  null
  
)

export default component.exports